import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import Modal from 'components/modal'
import IncentiveUpdateReasonsList from 'containers/interviews/incentive-update-reasons'

import 'less/edit-incentive-modal.less'

const EditIncentiveModal = props => {
  const initialIncentive = props.initialIncentive
  const [incentive, setIncentive] = useState(props.initialIncentive)
  const [showError, setShowError] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const [selectedReason, setSelectedReason] = useState(null)

  const debouncedSearch = debounce(props.fetchInterviewsList, 600)

  useEffect(() => {
    if (props.isUpdateSuccessful) {
      props.onClose()
      props.resetUpdateState()
      debouncedSearch()
    }
  }, [props.isUpdateSuccessful, props.onClose, props.resetUpdateState])

  const putIncentive = () => {
    const payload = {
      timeSlotId: props.timeSlotId,
      newValue: parseInt(incentive),
      oldValue: parseInt(initialIncentive),
      reasonCode: selectedReason
    }
    props.updateIncentive(payload)
  }

  let enableSubmit = parseInt(incentive) && parseInt(incentive) !== parseInt(initialIncentive) && !showError && selectedReason

  const validateIncentive = (value) => {
    const newValue = parseInt(value)
    const originalValue = parseInt(initialIncentive)
    
    setShowError(false)
    setShowWarning(false)
  
    if (newValue < originalValue) {
      setShowError(true)
      return
    }
  
    const percentageIncrease = ((newValue - originalValue) / originalValue) * 100
  
    if (percentageIncrease >= 200) {
      setShowError(true)
      return
    }
  
    if (percentageIncrease >= 100) {
      setShowWarning(true)
      return
    }
  }
  
  const handleIncentiveUpdateReasonChange = (selectedOption) => {
    const reason = selectedOption.value
    setSelectedReason(reason)
  }

  return (
    <Modal
      isOpen={props.isOpen}
      className="edit-incentive-modal"
      contentLabel={props.t('incentive.edit.title')}
      submitBtnText={props.t('incentive.edit.confirm')}
      onCancel={props.onClose}
      enableSubmit={enableSubmit && !props.isSubmitting}
      onSubmit={putIncentive}
      isSubmitting={props.isSubmitting}
      type='confirm-dialog'
    >
      <div className="react-dialog-confirm-msg">
        <p> {props.t('incentive.edit.message')}</p>
      </div>
      <div className={`incentive-container${showError ? "-error" : ""}`}>
        <span>{props.t('incentive.title')}:  </span>
        <div className='incentive-input-container'>
          <span className='incentive-currency'>
            {props.currency}
          </span>
          <input
            className="incentive-input"
            type="number"
            min="0"
            value={incentive}
            onChange={e => {
              setIncentive(e.target.value)
              validateIncentive(e.target.value)
            }}
          />
        </div>
      </div>
      {showError && 
        <div className="error-message">
          {parseInt(incentive) <= parseInt(initialIncentive) ? 
            props.t('incentive.edit.0.error.message') :
            props.t('incentive.edit.error.300')
          }
        </div>
      }
      {showWarning &&
        <div className="warning-message">
          <i className="im-warning warning-icon"></i>
          {props.t('incentive.edit.warning.200')}
        </div>
      }
      <div className='incentive-reason-container'>
        <span>{props.t('incentive.reason.title')}:  </span>
        <IncentiveUpdateReasonsList 
          onChange={handleIncentiveUpdateReasonChange}
          selectedReason={selectedReason}
        />
      </div>
    </Modal>
  )
}

const mapStateToProps = state => ({
  isSubmitting: state.updateIncentiveReducer.isUpdating,
  isUpdateSuccessful: state.updateIncentiveReducer.isUpdateSuccessful
})

const mapDispatchToProps = {
  updateIncentive: (payload) => ({ 
    type: 'UPDATE_INCENTIVE_REQUESTED', 
    payload 
  }),
  resetUpdateState: () => ({
    type: 'RESET_UPDATE_INCENTIVE_STATE'
  }),
  fetchInterviewsList: (payload) => ({
    type: 'FETCH_INTERVIEWS_LIST_REQUESTED',
    payload
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditIncentiveModal)